import React from 'react';
import styled, { keyframes } from 'styled-components';

const Bounce = keyframes`
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
`;

const Bouncer = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: #91c9c4;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  animation: ${Bounce} 2s infinite ease-in-out;
`;

const BounceContainer = styled.div`
  width: 40px;
  height: 40px;

  position: relative;
  margin: 100px auto;
`;

export default class ErrorText extends React.Component {
  render() {
    return (
      <BounceContainer>
        <Bouncer />
        <Bouncer style={{ animationDelay: '-1.0s' }} />
      </BounceContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SpinnerText.js